import { Box, IconButton } from '@material-ui/core';
import { useState } from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface SimulatorComponentProps {
  expandable?: boolean;
}

export const SimulatorComponent = ({ expandable = false }: SimulatorComponentProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { sm } = useScreen();

  const [opened, setOpened] = useState(false);

  if (!expandable) {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <Box
          style={{
            width: '100%',
            height: '800px',
            border: `solid 1px ${palette.divider}`,
            borderRadius: customBorderRadius.paper,
            overflow: 'hidden',
          }}
        >
          <div id="nemuru-simulator" style={{ width: '100%', height: '100%' }} />
        </Box>
      </div>
    );
  }

  return (
    <div>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <StandardButton
          size="small"
          color="default"
          variant="outlined"
          onClick={() => setOpened(true)}
          endIcon={<Icon size={16}>open_in_full</Icon>}
        >
          <Text tId={'MAXIMIZE'} />
        </StandardButton>
      </Box>
      {opened && <Box position="fixed" zIndex={100} style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', inset: 0 }} />}
      <CustomPaper
        style={{
          width: 'auto',
          position: opened ? 'fixed' : 'relative',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: palette.background.paper,
          padding: 0,
          ...(opened && { zIndex: 1000, inset: 16, padding: sm ? '16px 16px' : '8px 8px 16px' }),
        }}
      >
        {opened && (
          <IconButton
            size="small"
            style={{ position: 'absolute', top: 8, right: 8, zIndex: 10 }}
            onClick={() => setOpened(false)}
          >
            <Icon size={16}>close</Icon>
          </IconButton>
        )}
        <div
          style={{
            flexGrow: 1,
            padding: opened ? '16px' : 0,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <div
            id="nemuru-simulator"
            style={{
              height: '800px',
              overflowY: 'hidden',
              overflowX: 'auto',
              ...(opened && {
                height: '100%',
                border: `solid 1px ${palette.divider}`,
                borderRadius: customBorderRadius.paper,
              }),
            }}
          ></div>
        </div>
      </CustomPaper>
    </div>
  );
};
